export const notificationsCenterTabs = [
  { idx: 0, title: 'All Notifications', key: 'ALL', isCanadaRestricted: false },
  { idx: 1, title: 'Unavailable Items', key: 'UNAVAILABLE_ITEM', isCanadaRestricted: true },
  { idx: 2, title: 'Invalid Split Items', key: 'INVALID_SPLIT_ITEM', isCanadaRestricted: true },
];

export const notificationsCenterSteps = {
  NOTIFICATIONS_STEP: 1,
  INGREDIENT_REPLACEMENT_STEP: 2,
  SET_QUANTITY_STEP: 3,
};

export const notificationActions = {
  RESOLVE: 'RESOLVE',
  CLOSE: 'CLOSE',
  RESOLVE_CLOSE: 'RESOLVE_CLOSE',
  DIRECT_TO_LOCATION: 'DIRECT_TO_LOCATION',
};

export const notificationStatuses = {
  RESOLVED: 'RESOLVED',
  UNRESOLVED: 'UNRESOLVED',
  CLOSED: 'CLOSED',
  EXPIRED: 'EXPIRED',
}

export const notificationTypes = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
}

export const notificationCategory = {
  GLOBAL_PRICING: 'GLOBAL_PRICING',
}

/**
 * Source of the global-pricing resolve modal.
 * Can access from notification center, ingredient section, etc.
 */
export const source = {
  NOTIFICATIONS: 'NOTIFICATIONS',
  INGREDIENT_SECTION: 'INGREDIENT_SECTION',
}

export const resolveBypassSet = [source.INGREDIENT_SECTION]; // sources which can bypass notification center to resolve modal
